'use client'

import * as React from 'react'
import * as AlertDialogPrimitive from '@radix-ui/react-alert-dialog'


import './button.css'
import './alert-dialog.css'

function AlertDialog({
						 ...props
					 }: React.ComponentProps<typeof AlertDialogPrimitive.Root>) {
	return <AlertDialogPrimitive.Root data-slot="alert-dialog" {...props} />
}

function AlertDialogTrigger({
								...props
							}: React.ComponentProps<typeof AlertDialogPrimitive.Trigger>) {
	return (
		<AlertDialogPrimitive.Trigger data-slot="alert-dialog-trigger" {...props} />
	)
}

function AlertDialogPortal({
							   ...props
						   }: React.ComponentProps<typeof AlertDialogPrimitive.Portal>) {
	return (
		<AlertDialogPrimitive.Portal data-slot="alert-dialog-portal" {...props} />
	)
}

function AlertDialogOverlay({
								className,
								...props
							}: React.ComponentProps<typeof AlertDialogPrimitive.Overlay>) {
	return (
		<AlertDialogPrimitive.Overlay
			data-slot="alert-dialog-overlay"
			className={`alert-dialog-overlay ${className ?? ''}`.trim()}
			{...props}
		/>
	)
}

function AlertDialogContent({
								className,
								...props
							}: React.ComponentProps<typeof AlertDialogPrimitive.Content>) {
	return (
		<AlertDialogPortal>
			<AlertDialogOverlay />
			<AlertDialogPrimitive.Content
				data-slot="alert-dialog-content"
				className={`alert-dialog-content ${className ?? ''}`.trim()}
				{...props}
			/>
		</AlertDialogPortal>
	)
}

function AlertDialogHeader({
							   className,
							   ...props
						   }: React.ComponentProps<'div'>) {
	return (
		<div
			data-slot="alert-dialog-header"
			className={`alert-dialog-header ${className ?? ''}`.trim()}
			{...props}
		/>
	)
}

function AlertDialogFooter({
							   className,
							   ...props
						   }: React.ComponentProps<'div'>) {
	return (
		<div
			data-slot="alert-dialog-footer"
			className={`alert-dialog-footer ${className ?? ''}`.trim()}
			{...props}
		/>
	)
}

function AlertDialogTitle({
							  className,
							  ...props
						  }: React.ComponentProps<typeof AlertDialogPrimitive.Title>) {
	return (
		<AlertDialogPrimitive.Title
			data-slot="alert-dialog-title"
			className={`alert-dialog-title ${className ?? ''}`.trim()}
			{...props}
		/>
	)
}

function AlertDialogDescription({
									className,
									...props
								}: React.ComponentProps<typeof AlertDialogPrimitive.Description>) {
	return (
		<AlertDialogPrimitive.Description
			data-slot="alert-dialog-description"
			className={`alert-dialog-description ${className ?? ''}`.trim()}
			{...props}
		/>
	)
}

function AlertDialogAction({
							   className,
							   variant = 'default',
							   ...props
						   }: React.ComponentProps<typeof AlertDialogPrimitive.Action> & {
	variant?: 'default' | 'destructive' | 'action'
}) {
	return (
		<AlertDialogPrimitive.Action
			data-variant={variant}
			data-size="default"
			className={`button ${className ?? ''}`.trim()}
			{...props}
		/>
	)
}

function AlertDialogCancel({
							   className,
							   ...props
						   }: React.ComponentProps<typeof AlertDialogPrimitive.Cancel>) {
	return (
		<AlertDialogPrimitive.Cancel
			data-variant="outline"
			data-size="default"
			className={`button ${className ?? ''}`.trim()}
			{...props}
		/>
	)
}

export {
	AlertDialog,
	AlertDialogPortal,
	AlertDialogOverlay,
	AlertDialogTrigger,
	AlertDialogContent,
	AlertDialogHeader,
	AlertDialogFooter,
	AlertDialogTitle,
	AlertDialogDescription,
	AlertDialogAction,
	AlertDialogCancel,
}
